<div class="modal-content funding">
    <div class="modal-header border-0">
        <h3 class="modal-title" id="modulesModalLabel">Cancelar evento</h3>
        <button type="button" class="btn-close" (click)="modalCancelEvent.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form [formGroup]="cancelEventForm"  class="row needs-validation" novalidate="">
            <div class="row">
                <div class="email-wrapper col-sm-12">
                    <div class="theme-form">
                        <div class="mb-3">
                            <label class="w-100">Motivo de cancelación:</label>
                            <!-- Textarea Field -->
                            <textarea class="form-control" id="event_description" placeholder=""
                                      rows="3" required="true" formControlName="reason_cancellation"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <!-- Botones form-->
        <div class="d-flex justify-content-end gap-2 mt-2">
            <button type="button" class="btn btn-secondary col-auto" (click)="cancelForm()">Cancelar</button>
            <button type="button" class="btn btn-primary col-auto" (click)="cancelEvent()">Continuar con la cancelación</button>
        </div>
    </div>
</div>
